// extracted by mini-css-extract-plugin
export var option = "_2f-0";
export var optionSelected = "_2f-1 _2f-0";
export var optionUnselected = "_2f-2 _2f-0";
export var radioInner = "_2f-5";
export var radioOuter = "_2f-3";
export var radioOuterSelected = "_2f-4 _2f-3";